import React from "react";
import Hero from "./hero2/Hero";
import HAbout from "./HAbout";
import AboutCard from "../about/AboutCard";
import Header from "../common/header/Header";
import Footer from "../../componant/Footer";
import HeroSection from "./HeroSection";
const Home = () => {
  return (
    <>
{/* <Header/> */}
      <Hero  />
      <AboutCard />
      <HAbout />
      <HeroSection/>
        <Footer/>
    </>
  );
};

export default Home;
